<template>
  <div
    class="html_svgCircle_valTypeForString"
    ref="html_svgCircle_valTypeForString"
    v-if="datas.objectInfo && datas.objectInfo.length > 1"
  >
    <div class="main">
      <div class="headerArea">
        <template v-if="themetype === 'T'">
          <DelegationImgRow
            v-for="(item, itemIndex) in datas.objectInfo"
            :key="item.teamId"
            :countryImg="item.teamLogo"
            :countryName="item.teamName"
            :cssDynamicObj="cssDynamicObj"
            :width="'100%'"
            :logoWidth="'calc(3.6vw * var(--mixtmt_mixvw))'"
            :logoHeight="'calc(2.4vw * var(--mixtmt_mixvw))'"
            :direction="delegationImgRow_directionArr[itemIndex]"
          ></DelegationImgRow>
        </template>
      </div>
      <div class="teamStatMain_item">
        <div class="itemPer_row" v-for="row in teamStatArr" :key="row.key">
          <span class="containerVal home">
            <span
              class="containerVal_row"
              v-for="item in row.homeItem"
              :key="item.key"
            >
              <span class="row_name" v-text="item.name"></span>
              <span class="row_val" v-text="item.value"></span>
            </span>
          </span>
          <div class="per_contain">
            <cup_svgSingleCircle
              v-if="cy"
              :currThemeObj="currThemeObj"
              teamMode="home"
              :cx="cx"
              :cy="cy"
              :strokeWidth="strokeWidth"
              :svgData="row.svgData[0] ? row.svgData[0] : defaultSvgData"
              :keyArr="cup_svgSingleCircle_keyArr"
              :svgCenterInforArr="['val']"
              :svgCenterInforTextFontSizeArr="svgCenterInforTextFontSizeArr"
              :svgCenterBgColorArr="svgCenterBgColorArr"
              :svgCenterColorArr="svgCenterColorArr"
            ></cup_svgSingleCircle>
          </div>
          <div class="itemPer_title" v-text="`${row.title}`"></div>
          <div class="per_contain">
            <cup_svgSingleCircle
              v-if="cy"
              :currThemeObj="currThemeObj"
              teamMode="away"
              :cx="cx"
              :cy="cy"
              :strokeWidth="strokeWidth"
              :svgData="row.svgData[1] ? row.svgData[1] : defaultSvgData"
              :keyArr="cup_svgSingleCircle_keyArr"
              :svgCenterInforArr="['val']"
              :svgCenterInforTextFontSizeArr="svgCenterInforTextFontSizeArr"
              :svgCenterBgColorArr="svgCenterBgColorArr"
              :svgCenterColorArr="svgCenterColorArr"
            ></cup_svgSingleCircle>
          </div>
          <span class="containerVal away">
            <span
              class="containerVal_row"
              v-for="item in row.awayItem"
              :key="item.key"
            >
              <span class="row_name" v-text="item.name"></span>
              <span class="row_val" v-text="item.value"></span>
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 运动员数据对比 - val为直接展示的 string
import DelegationImgRow from '../components/DelegationImgRow'
import cup_svgSingleCircle from '@components/platfromBase/football/cup_svgSingleCircle.vue'
export default {
  name: 'html_svgCircle_valTypeForString',
  // mixins: [htmlDomToImage_base64_data_mixin],
  components: {
    DelegationImgRow,
    cup_svgSingleCircle,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    currThemeObj: {
      type: Object,
      default: null,
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
  },
  data() {
    return {
      delegationImgRow_directionArr: ['left', 'right'],
      defaultSvgData: {
        val: 10,
        name: '11',
        key: 1,
      },
      cup_svgSingleCircle_keyArr: ['name', 'val'],
      strokeWidthVw: 0.68,
      bodyWidth: 0,
      cxVw: 2.5,
      cyVw: 2.5,
      // teamStatArr: null,
      svgCenterInforTextFontSizeArr: ['1.11vw', '0.974vw', '1.25vw'],
      svgCenterBgColorArr: ['#0972BA', '#013C6F'],
      svgCenterColorArr: ['rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 1)'],
    }
  },
  watch: {},
  created() {
    // 模拟数据
    console.debug(this.datas)

    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.$nextTick(() => {
      // 设置CSS变量--main-bg-color的值为'#f0f0f0'
      document.body.style.setProperty(
        '--mixtmt_indicatorItemSelect_mixvw',
        this.cssDynamicObj.mixvw
      )

      this.onResizeEvent()
    })
  },
  // updated() {
  //   console.debug(`更新： ${this.datas}`)
  // },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  computed: {
    themetype() {
      return 'T'
    },
    strokeWidth() {
      return Math.ceil((this.bodyWidth / 100) * this.strokeWidthVw)
    },
    cx() {
      return Math.ceil((this.bodyWidth / 100) * this.cxVw)
    },
    cy() {
      return Math.ceil((this.bodyWidth / 100) * this.cyVw)
    },
    teamStatArr() {
      let teamStatArr = []
      const dataList = this.datas.data.dataList
      const statisticsModels = this.datas.statisticsModels
      if (
        dataList &&
        dataList.length > 0 &&
        statisticsModels &&
        statisticsModels.length % 3 === 0
      ) {
        // 数据和 statisticsModels 的个数都符合
        const home = dataList[0]
        const away = dataList[1] ? dataList[1] : null
        const initKeysItemArr = []
        let keysItem = []
        statisticsModels.forEach((keyItem, keyIndex) => {
          if (keyIndex % 3 === 0) {
            keysItem = []
          }
          keysItem.push(keyItem)
          if (keyIndex % 3 === 2) {
            initKeysItemArr.push(keysItem)
          }
        })
        console.debug('initKeysItemArr:', initKeysItemArr)
        if (initKeysItemArr && initKeysItemArr.length > 0) {
          initKeysItemArr.forEach((rowItem, rowIndex) => {
            let svgData = []
            let homeItem = []
            let awayItem = []
            let rowTitle = ''
            rowItem.forEach((keyItem, keyIndex) => {
              if (keyIndex === 2) {
                rowTitle = keyItem.suffix
                  ? `${keyItem.name}(${keyItem.suffix})`
                  : keyItem.name
                if (home) {
                  svgData.push({
                    name: '',
                    val: `${home[keyItem.statisticalEn]}`,
                    key: `home_${keyItem.statisticalEn}`,
                  })
                }
                if (away) {
                  svgData.push({
                    name: '',
                    val: `${away[keyItem.statisticalEn]}`,
                    key: `away_${keyItem.statisticalEn}`,
                  })
                }
              } else {
                let key = keyItem.statisticalEn
                if (home) {
                  homeItem.push({
                    key,
                    name: keyItem.name,
                    value: `${home[keyItem.statisticalEn]}`,
                  })
                }
                if (away) {
                  awayItem.push({
                    key,
                    name: keyItem.name,
                    value: `${away[keyItem.statisticalEn]}`,
                  })
                }
              }
            })
            teamStatArr.push({
              key: `row_${rowIndex}`,
              title: rowTitle,
              svgData,
              homeItem,
              awayItem,
            })
          })
        }
      }
      return teamStatArr
    },
    // countryLogoSize() {
    //   if (
    //     this.datas &&
    //     this.datas.sportType === 'basketball' &&
    //     this.datas.competitionType === 'league'
    //   ) {
    //     return [
    //       'calc(1.666vw * var(--mixtmt_mixvw))',
    //       'calc(1.666vw * var(--mixtmt_mixvw))',
    //     ] //['1.666vw', '1.666vw']
    //   } else {
    //     return [
    //       'calc(2.498vw * var(--mixtmt_mixvw))',
    //       'calc(1.666vw * var(--mixtmt_mixvw))',
    //     ] //['2.498vw', '1.666vw']
    //   }
    // },
    // team2CountryLogoSize() {
    //   if (
    //     this.datas &&
    //     this.datas.sportType === 'basketball' &&
    //     this.datas.competitionType === 'league'
    //   ) {
    //     return [
    //       'calc(5vw * var(--mixtmt_mixvw))',
    //       'calc(5vw * var(--mixtmt_mixvw))',
    //     ] //['5vw', '5vw']
    //   } else {
    //     return [
    //       'calc(4.5vw * var(--mixtmt_mixvw))',
    //       'calc(3vw * var(--mixtmt_mixvw))',
    //     ] //['4.5vw', '3vw']
    //   }
    // },
    // midBoxFontSizeArr() {
    //   let titleCenter_fontSize = 'calc(0.974vw * var(--mixtmt_mixvw))' //'0.974vw'
    //   if (
    //     this.datas &&
    //     this.datas.statisticsModels &&
    //     this.datas.statisticsModels.length > 0
    //   ) {
    //     this.datas.statisticsModels.forEach((item) => {
    //       if (item.name && item.name.length > 7) {
    //         titleCenter_fontSize = 'calc(0.833vw * var(--mixtmt_mixvw))' //'0.833vw'
    //       }
    //     })
    //   }
    //   return [titleCenter_fontSize]
    // },
  },
  methods: {
    onResizeEvent() {
      this.parentWidthPx =
        this.$refs.html_svgCircle_valTypeForString.clientWidth
      this.bodyWidth = document.body.clientWidth
    },
    _valFormatHandler(val, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (val && ceil) {
          data = `${val}${ceil ? ceil : ''}`
        } else {
        }
        data = val + ''
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_svgCircle_valTypeForString {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    position: relative;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    color: var(--mixtmt_greyColor_main);
    .headerArea {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 calc(0.974vw * var(--mixtmt_mixvw))
        calc(1.11vw * var(--mixtmt_mixvw)) calc(0.974vw * var(--mixtmt_mixvw));
    }
    .teamStatMain_item {
      width: 100%;
      height: auto;
      max-height: 17.082vw;
      overflow: auto;
    }
    .itemPer_row {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 5vw;
      margin-bottom: 0.694vw;
      background: linear-gradient(
        90deg,
        var(--mixtmt_svgCircle_valTypeForString_rowBgColor1_1) 0%,
        var(--mixtmt_svgCircle_valTypeForString_rowBgColor1_2) 52%,
        var(--mixtmt_svgCircle_valTypeForString_rowBgColor1_3) 100%
      );

      &:last-child {
        margin-bottom: 0;
      }
      .containerVal {
        width: calc(50% - 5vw - 4.87vw);
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        &.home {
          .containerVal_row {
            .row_name {
              text-align: right;
            }
            .row_val {
              color: var(--mixtmt_svgSingleColor1_1);
            }
          }
        }
        &.away {
          .containerVal_row {
            flex-direction: row-reverse;
            .row_name {
              text-align: left;
            }
            .row_val {
              color: var(--mixtmt_svgSingleColor2_1);
            }
          }
        }
        .containerVal_row {
          width: 100%;
          height: 2vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 0.974vw;
          font-weight: bold;
          .row_name {
            color: var(--mixtmt_svgCircle_valTypeForString_titleColor);
            width: calc(100% - 3.47vw);
          }
          .row_val {
            width: 3.47vw;
            text-align: center;
          }
        }
      }
      .per_contain {
        width: 5vw;
      }
      .itemPer_title {
        width: 9.74vw;
        text-align: center;
        font-size: 1.11vw;
        font-weight: bold;
        color: var(--mixtmt_svgCircle_valTypeForString_titleColor);
      }
    }
  }
}
</style>
